import { render, staticRenderFns } from "./chatlist.vue?vue&type=template&id=227a584a&scoped=true&"
import script from "./chatlist.vue?vue&type=script&lang=js&"
export * from "./chatlist.vue?vue&type=script&lang=js&"
import style0 from "./chatlist.vue?vue&type=style&index=0&id=227a584a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a584a",
  null
  
)

export default component.exports